import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import LiquidityLadderCriteria from "./LiquidityLadderCriteria";
import { Neo } from "@singularsystems/neo-react";
import { ReportCategory } from "../ReportCategory";

@NeoReport("LiquidityLadder", { category: ReportCategory.CombinedReports })
export default class LiquidityLadderReport extends Report<LiquidityLadderCriteria> {

    constructor() {
        super(LiquidityLadderCriteria);
    }

    public renderCriteria() {
        return <Neo.GridLayout>
            <div>
                <Neo.FormGroupInline bind={this.criteria.meta.reportDate} />

                <Neo.FormGroupInline bind={this.criteria.meta.projectionDate} />
            </div>
        </Neo.GridLayout>
    }
}